<section class="about-us" id="nosotros">
    <!-- <div class="container"> -->

    <!-- <div class="content"> -->
    <div class="container">
        <div class="text-content">
            <div class="header">
                <app-badge text="Quiénes Somos"></app-badge>
                <h2 class="title">Acerca de Nosotros</h2>
            </div>
            <p class="text-description">Somos una empresa familiar que cree que construir va más allá de levantar
                estructuras. Nuestro propósito es impulsar el desarrollo industrial, comercial y urbano de México a
                través de proyectos que reflejen calidad, compromiso y confianza.</p>
            <p class="text-description">Cada Obra representa una oportunidad para crear valor duradero, mejorar
                comunidades y fortalecer relaciones que trascienden los contratos.</p>
            
            <div class="brands-trust">
                <div class="circles-container">
                    <div class="circle circle-1">
                        <img src="assets/images/partners_webp/la-salle-logo.webp" alt="La Salle" width="48" height="48" loading="lazy" decoding="async">
                    </div>
                    <div class="circle circle-2">
                        <img src="assets/images/partners_webp/LOreal-Logo.webp" alt="L'Oréal" width="48" height="48" loading="lazy" decoding="async">
                    </div>
                    <div class="circle circle-3">
                        <img src="assets/images/partners_webp/Nestle.webp" alt="Nestlé" width="48" height="48" loading="lazy" decoding="async">
                    </div>
                </div>
                <p class="trust-text">+ 10 marcas confiaron en nosotros</p>
            </div>
                
        </div>
        <div class="image-container">
            <img src="assets/images/home/about-us-picture.webp" alt="Acerca de Nosotros" width="1024" height="1024" loading="lazy" decoding="async">
        </div>
    </div>
    <!-- </div> -->
    <!-- </div> -->
</section>
